<template>
  <div>
    <transition name="slide-fade">
      <div class="modal" v-show="modalCustomerData.addable">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">开通账号</h5>
              <button type="button" class="close" @click="closeClick">
                <i class="ki ki-close"></i>
              </button>
            </div>
            <div class="modal-body body_margin text-center">
              <div v-if="modalCustomerData.formShow">
                <div>
                  即将为<span class="font-weight-boldest">{{
                    modalCustomerData.name
                  }}</span
                  >开通{{type}}控制台账号
                </div>
                <div class="mt-4">
                  <vi-form
                    :fields="fields"
                    ref="rForm"
                    v-model="modalCustomerData.args"
                  ></vi-form>
                </div>
                <div class="mt-2 text-muted">
                  登录账号默认为客户的手机号和邮箱，可指定
                </div>
              </div>
              <div v-else class="customer_account">
                <div class="text-success">
                  账号开通成功<vi-icon
                    :name="icon"
                    :size="size"
                    :color="color"
                    class="ml-3"
                  ></vi-icon>
                </div>
                <div class="row mt-3">
                  <span class="col-5 text-right">手机号：</span
                  ><span>{{ modalCustomerData.args.mobile }}</span>
                </div>
                <div class="row mt-3">
                  <span class="col-5 text-right">邮箱：</span
                  ><span>{{ modalCustomerData.args.email }}</span>
                </div>
                <div class="row mt-3">
                  <span class="col-5 text-right">初始密码：</span
                  ><span>{{ modalCustomerData.password }}</span>
                </div>
                <!-- <div class="text-primary mt-3 custome_p" @click="eCopy">
                  复制
                </div> -->
              </div>
            </div>
            <div class="modal-footer">
              <div v-if="modalCustomerData.formShow">
                <button
                  type="button"
                  class="btn btn-primary font-weight-bold close_ctrl"
                  @click="confirmClick"
                >
                  确定
                </button>
                <button
                  type="button"
                  class="btn btn-light-dark font-weight-bold close_ctrl ml-2"
                  @click="cancelClick"
                >
                  取消
                  <!-- {{modalCustomerData.formShow === false ?"确定":"取消"}} -->
                </button>
              </div>
              <div v-else>
                <button
                  type="button"
                  class="btn btn-dark font-weight-bold close_ctrl"
                  @click="cormClick"
                >
                  复制并关闭
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="modal-backdrop" v-show="modalCustomerData.backdropShow"></div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "CustomerAddModalCtrl",
  data() {
    return {
      fields: [
        {
          name: "mobile",
          type: "text",
          label: "手机号",
          maxlength: 64,
          validation: {
            items: [{ type: "Required", invalid: "该项必填" }],
          },
        },
        {
          name: "email",
          type: "text",
          label: "邮箱",
          maxlength: 64,
          validation: {
            items: [{ type: "Required", invalid: "该项必填" }],
          },
        },
      ],
      icon: "fas:check-circle",
      size: "15px",
      color: "success",
    };
  },
  mounted() {
    this.$refs.rForm.reset(this.modalCustomerData.args);
  },
  methods: {
    confirmClick() {
      this.$emit("e-confirm");
    },
    closeClick() {
      this.$emit("input", false);
    },
    cancelClick() {
      this.$emit("e-cancel");
      this.$emit("input", false);
    },
    cormClick() {
      this.eCopy();
      this.$emit("e-cancel");
    },
    eCopy() {
      let url = `
      ${this.modalCustomerData.name} \r\n
      手机号：${this.modalCustomerData.args.mobile}\r\n 
      邮箱：${this.modalCustomerData.args.email}\r\n
      初始密码：${this.modalCustomerData.password}\r\n
     【注意】初次登录后请及时修改密码
      `;
      this.$$.clipboard.copyText(url);
      this.$$.toastr.success("复制成功！");
    },
  },
  props: {
    modalCustomerData: Object,
    type:String
  },
};
</script>

<style lang="scss" scoped>
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0 !important;
}
.modal-backdrop { 
  transition: opacity 0.3s linear;
  opacity: 0.2;
}
.modal {
  display: block;
}
.custome_p {
  cursor: pointer;
}
.modal-footer {
  justify-content: center;
  border-top: none;
  .close_ctrl {
    width: 120px;
    color: #fff;
  }
}
.body_margin {
  .body_card {
    margin-top: 20px;
    div {
      margin: 5px 0px;
    }
  }
}
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-50px);
  opacity: 0;
}
.body_title {
  font-size: 16px;
  color: #101010;
}
</style>
